"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionsSheetScreen = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importStar(require("styled-components"));
const subs_sheet_female_png_1 = __importDefault(require("../../assets/images/subs-sheet-female.png"));
const subs_sheet_male_png_1 = __importDefault(require("../../assets/images/subs-sheet-male.png"));
const SubscriptionsSheetTitle_1 = require("../../molecules/SubscriptionsSheetTitle/SubscriptionsSheetTitle");
const SubscriptionFeatures_1 = require("../SubscriptionFeatures/SubscriptionFeatures");
const SubscriptionsSheetPurchase_1 = __importDefault(require("../SubscriptionsSheetPurchase/SubscriptionsSheetPurchase"));
function SubscriptionsSheetScreen({ licenses, isActiveTrial, isDesktop, isLandscape, isMobile, isShowTable, recommendedLicense, selectedLicense, t, onShowLoginClick, onBuyClick, onSetSelectedLicense, }) {
    const isMobilePortrait = isMobile && !isLandscape;
    return ((0, jsx_runtime_1.jsxs)(MainContent, { isLandscape: isLandscape, isMobile: isMobile, "data-e2e": 'SubscriptionsSheetScreen_MainContent', children: [(0, jsx_runtime_1.jsx)(ImageContainer, { "data-e2e": 'SubscriptionsSheetScreen_ImageContainer', children: !isMobilePortrait && ((0, jsx_runtime_1.jsx)(LeftImage, { isDesktop: isDesktop, isMobile: isMobile, isLandscape: isLandscape, src: subs_sheet_female_png_1.default, alt: "female-model", "data-e2e": 'SubscriptionsSheetScreen_LeftImage' })) }), (0, jsx_runtime_1.jsxs)(MiddleContainer, { isActiveTrial: isActiveTrial, isDesktop: isDesktop, isLandscape: isLandscape, isMobile: isMobile, "data-e2e": 'SubscriptionsSheetScreen_MiddleContainer', children: [(0, jsx_runtime_1.jsx)(SubscriptionsSheetTitle_1.SubscriptionsSheetTitle, { isActiveTrial: isActiveTrial, isShowTable: isShowTable, isLandscape: isLandscape, isMobile: isMobile, "data-e2e": 'SubscriptionsSheetScreen_SubscriptionsSheetTitle' }), isShowTable ? ((0, jsx_runtime_1.jsx)(SubscriptionFeatures_1.SubscriptionFeatures, { handleSignIn: onShowLoginClick, isActiveTrial: isActiveTrial, t: t, isLandscape: isLandscape, isMobile: isMobile, "data-e2e": 'SubscriptionsSheetScreen_SubscriptionFeatures' })) : ((0, jsx_runtime_1.jsx)(SubscriptionsSheetPurchase_1.default, { isLandscape: isLandscape, isMobile: isMobile, recommendedLicense: recommendedLicense, selectedLicense: selectedLicense, onLicenseBuy: onBuyClick, onSetSelectedLicense: onSetSelectedLicense, licenses: licenses, t: t, "data-e2e": 'SubscriptionsSheetScreen_SubscriptionsSheetPurchase' }))] }), (0, jsx_runtime_1.jsx)(ImageContainer, { "data-e2e": 'SubscriptionsSheetScreen_ImageContainer', children: !isMobilePortrait && ((0, jsx_runtime_1.jsx)(RightImage, { isDesktop: isDesktop, isMobile: isMobile, isLandscape: isLandscape, src: subs_sheet_male_png_1.default, alt: "male-model", "data-e2e": 'SubscriptionsSheetScreen_RightImage' })) })] }));
}
exports.SubscriptionsSheetScreen = SubscriptionsSheetScreen;
const MainContent = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  width: 100%;
  max-width: 100vw;
  padding-top: 2em;

  overflow: hidden;
  background-color: #11151c;

  ${({ isMobile, isLandscape }) => {
    if (isMobile && isLandscape) {
        //For overlapping nav design.
        return `      
      z-index: 0;
      position: absolute;
      top: 0;
    `;
    }
    else if (isMobile && !isLandscape) {
        return `
      padding-top: 0;
    `;
    }
}}

  ${({ isMobile }) => !isMobile &&
    ui_1.device.tablet((0, styled_components_1.css) `
      height: 96vh;
    `)}
`;
const MiddleContainer = styled_components_1.default.div `
  z-index: 10;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  min-width: fit-content;
  height: 100%;
  margin: auto;
  margin-bottom: 25vh;
  padding-top: 16px;

  overflow: auto;
  gap: 10px;

  ${({ isActiveTrial }) => isActiveTrial &&
    ui_1.devicePortrait.mobileM((0, styled_components_1.css) `
      padding-top: 15%;
    `)}

  ${({ isMobile }) => isMobile &&
    ui_1.devicePortrait.mobileM((0, styled_components_1.css) `
      margin-bottom: 28vh;
    `)}

  ${({ isMobile }) => isMobile &&
    ui_1.deviceLandscape.mobileM((0, styled_components_1.css) `
      margin-bottom: 20%;
    `)}

  ${({ isMobile }) => !isMobile &&
    ui_1.device.tablet((0, styled_components_1.css) `
      justify-content: center;
      height: 78vh;
      padding-top: 0;
    `)}
`;
const ImageContainer = styled_components_1.default.div `
  z-index: 0;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;

  width: 100px;
  min-width: 25vw;
  height: 98%;
`;
const LeftImage = styled_components_1.default.img `
  position: relative;
  object-fit: cover;
  bottom: 0;

  ${({ isMobile, isLandscape }) => isMobile &&
    isLandscape &&
    `
      position: fixed;
      margin-bottom: 50px;
      width: 25vw;
      left: -5%;
  `};

  //For tablets.
  ${({ isMobile }) => !isMobile &&
    ui_1.deviceLandscape.all((0, styled_components_1.css) `
      max-width: 55vw;
      left: 40%;
      bottom: -2em;
    `)}

  ${({ isDesktop }) => isDesktop &&
    ui_1.deviceLandscape.tablet((0, styled_components_1.css) `
      max-width: 50vw;
      left: 40%;
    `)}

  ${ui_1.deviceLandscape.laptopL((0, styled_components_1.css) `
    max-width: 45vw;
    left: 10%;
  `)}

  ${ui_1.deviceLandscape.desktop((0, styled_components_1.css) `
    max-width: 40vw;
    left: 6vw;
  `)}
`;
const RightImage = styled_components_1.default.img `
  position: relative;
  object-fit: cover;

  //For mobile landscape.
  ${({ isMobile, isLandscape }) => isMobile &&
    isLandscape &&
    `
      position: fixed;
      margin-bottom: 50px;
      width: 25vw;
      bottom: 0;
      right: -5%;
  `};

  ${({ isMobile }) => !isMobile &&
    ui_1.deviceLandscape.all((0, styled_components_1.css) `
      max-width: 55vw;
      bottom: -2em;
      left: 70%;
    `)}

  ${({ isDesktop }) => isDesktop &&
    ui_1.deviceLandscape.tablet((0, styled_components_1.css) `
      max-width: 50vw;
      bottom: 0;
      left: 40%;
    `)}

  ${ui_1.deviceLandscape.laptopL((0, styled_components_1.css) `
    max-width: 45vw;
    bottom: 0;
    left: 60%;
  `)}

  ${ui_1.deviceLandscape.desktop((0, styled_components_1.css) `
    max-width: 40vw;
    bottom: 0;
    left: 6vw;
  `)}
`;
